import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Avatar, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, makeStyles, tokens } from '@fluentui/react-components';
import { loginRequest } from '../auth/msalConfig';
import { useLoginButtonStyles } from './LoginButton.styles';

const useStyles = makeStyles({
    avatar: {
        cursor: 'pointer',
        width: '36px',
        height: '36px',
    },
    loginButton: {
        cursor: 'pointer',
        padding: '8px 16px',
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        border: 'none',
        borderRadius: tokens.borderRadiusMedium,
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        ':hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
        },
        ':active': {
            backgroundColor: tokens.colorBrandBackgroundPressed,
        },
    },
});

export const LoginButton: React.FC = () => {
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const styles = useStyles();
    const loginStyles = useLoginButtonStyles();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch((error) => {
            console.error('Login failed:', error);
        });
    };

    const handleLogout = () => {
        instance.logoutRedirect({
            account: accounts[0],
        }).catch((error) => {
            console.error('Logout failed:', error);
        });
    };

    if (!isAuthenticated) {
        return (
            <button
                onClick={() => handleLogin()}
                className={styles.loginButton}
                aria-label="Sign in"
            >
                Sign in
            </button>
        );
    }

    const account = accounts[0];
    const displayName = account?.name || account?.username || 'User';
    const initials = displayName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .substring(0, 2);

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <Avatar
                    name={displayName}
                    initials={initials}
                    className={styles.avatar}
                    aria-label={`User menu for ${displayName}`}
                />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem disabled>
                        <div className={loginStyles.userInfo}>
                            <div className={loginStyles.displayName}>{displayName}</div>
                            <div className={loginStyles.username}>
                                {account?.username}
                            </div>
                        </div>
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>Sign out</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};
